import Vue from 'vue'
import Vuex from 'vuex'

import camelCase from 'lodash/camelCase'

Vue.use(Vuex)

const registerStoreModules = () => {
  const requireModule = require.context('@/store/modules/', true, /\.js$/)
  const modules = {}

  requireModule.keys().forEach(filename => {
    const moduleName = camelCase(filename.replace(/(\.\/|\.js)/g, '').replace('Index.js'))
    modules[moduleName] = {
      ...requireModule(filename).default,
      namespaced: true
    }
  })
  return modules
}

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: registerStoreModules()
})
